export const DEFAULT_STATE = [];

export default function reducer(state: any = DEFAULT_STATE, action: any = {}) {
    if (action.type && action.type.substring(action.type.length - 4) === 'FAIL') {
        const timestamp = Date.now();
        const error = {
            ...action,
            timestamp,
        };

        return [...state, error];
    }

    return state;
}
